module.exports = __webpack_public_path__ + "static/media/litho_border.170dad9c.jpg";